<template>
  <div
    class="asd20-organization-picker"
    :class="{ 'asd20-organization-picker--reversed': reversed }"
  >
    <asd20-picker
      :class="{ 'asd20-picker--reversed': reversed }"
      icon="star"
      cookieLabel="OrganizationPicker"
      :items="organizationOptions"
      :itemsByCategory="orgItemsByCategory"
      :modalLabel="modalLabel"
      :reversed="reversed"
      :organization="organization"
    >
      <asd20-district-logo
        v-if="organization.title === 'Academy District 20'"
      ></asd20-district-logo>
      <asd20-logo
        v-if="organization.title !== 'Academy District 20'"
        :title="orgTitle"
        :subtitle="orgLevel"
        :image="organization.logoImageUrl"
        :link="organization.website"
        :size="logoSize"
        bordered
        :reversed="reversed"
        :abbreviated="abbreviated"
      />
    </asd20-picker>
  </div>
</template>

<script>
import Asd20DistrictLogo from '../../../components/atoms/Asd20DistrictLogo'
import Asd20Picker from '../../molecules/Asd20Picker'
import Asd20Logo from '../../atoms/Asd20Logo'
import {
  organizationLevel,
  organizationName,
} from '../../../helpers/organization.js'

export default {
  name: 'Asd20OrganizationPicker',
  components: {
    Asd20DistrictLogo,
    Asd20Picker,
    Asd20Logo,
  },
  props: {
    organization: { type: Object, default: () => {} },
    organizationOptions: { type: Array, default: () => [] },
    // orgTitle: { type: String, default: '' },
    // orgLevel: { type: String, default: '' },
    reversed: { type: Boolean, default: false },
    modalLabel: { type: String, default: 'Change Schools' },
    logoSize: { type: String, default: 'md' },
    abbreviated: { type: Boolean, default: false },
  },

  computed: {
    // mq() {
    //   return this.$mq || 'sm'
    // },
    orgItemsByCategory() {
      let categories = ['Elementary', 'Middle', 'High']
      let sorted = []
      for (const c of categories) {
        sorted.push({
          title: c,
          itemsSorted: this.sortOrgsByLevel(this.organizationOptions, c),
        })
      }
      return sorted
    },

    orgTitle() {
      return organizationName(this.organization.title)
    },
    orgLevel() {
      return organizationLevel(this.organization.title)
    },
  },
  methods: {
    sortOrgsByLevel(orgs, level) {
      return orgs
        .filter(o => {
          if (o.educationLevels.includes(level)) {
            return o
          }
        })
        .sort((a, b) => {
          if (a.label < b.label) return -1
          if (a.label > b.label) return 1
          return 0
        })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../design/_variables.scss';
@import '../../../design/_mixins.scss';

.asd20-organization-picker {
  .asd20-district-logo {
    padding: space(0.5) 0 space(0.5) space(0.25);
    &::v-deep svg {
      height: inherit;
    }
  }
}
@media (min-width: 768px) {
  .asd20-organization-picker {
    .asd20-district-logo {
      height: space(1.75);
      padding-left: 0 !important;
    }
  }
}

@media (min-width: 1024px) {
  .asd20-organization-picker {
    .asd20-district-logo {
      margin: space(1) auto space(1) 0;
      // display: flex;
      --fill-one: var(--color__primary);
      --fill-two: var(--color__secondary-t30);
    }
    &--reversed {
      .asd20-district-logo {
        height: space(1.5);
        margin: space(1) auto space(1) 0;
        // display: block;
        --fill-one: #fff;
        --fill-two: #ccc;
      }
    }
  }
}
</style>
